module.exports = __webpack_public_path__ + "static/media/ms-sql-server.818bb717.svg";